import CustomerTicket from "./component/CustomerTicket";

export default CustomerTicket;
